import { Skeleton } from "@mui/material";
import { styled } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import RightArrowIcon from "src/icons/portfolio/RightArrowIcon";
import CopyOnClick from "src/utils/hooks/useCopy";
import { IReferralData } from "../defaults";
import { trackEvent } from "src/Amplitude";

export const ReferLinkWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  width: "100%",
}));

export const ReferLinkHeader = styled(RouterLink)({
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "6px",
  zIndex: 1,
  fontSize: "16px",
  fontWeight: 600,
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
});

export const ReferLinkSubHeader = styled("div")({
  flex: "1 0 0",
});

export const ReferLinkSubHeaderIcon = styled("div")({
  cursor: "pointer",
});

export const ReferLinkText = styled("div")({
  color: "#790202",
  fontSize: "12px",
});

export const ReferShareLink = styled("div")({
  display: "flex",
  fontSize: "12px",
  padding: "2px 2px 2px 8px",
  justifyContent: "space-between",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "4px",
  borderRadius: "16px",
  border: "1px dashed  #002035",
});

export const RaFCode = styled("div")({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const ReferShareButton = styled("div")({
  display: "flex",
  padding: " 4px 12px",
  alignItems: "center",
  gap: "4px",
  borderRadius: "16px",
  background: "#002035",
  color: "#FFF",
  cursor: "pointer",
  userSelect: "none",
  fontSize: "14px",

  /* Shadow (MD)/Standard */
  boxShadow: "0px 8px 16px 0px rgba(216, 216, 218, 0.90)",

  "&:hover": {
    background: "#4E7086",
  },

  "&:focus": {
    backgroundColor: "#E8F6FF",
    color: "#002035",
  },
});

interface MobileReferralProps {
  isLoading: boolean;
  data: IReferralData;
}

const MobileReferral = (props: MobileReferralProps) => {
  const { isLoading, data } = props;

  const handleAmplitudeTracking = () => {
    trackEvent("Shared code", { component: "MobileReferral" }, "RaF");
  };

  if (isLoading) return <Skeleton variant="rounded" width={"100%"} height={"121px"} />;

  return (
    <ReferLinkWrapper>
      <ReferLinkHeader to="/refer-a-friend">
        <ReferLinkSubHeader>Share your code to start earning today!</ReferLinkSubHeader>
        <ReferLinkSubHeaderIcon>
          <RightArrowIcon />
        </ReferLinkSubHeaderIcon>
      </ReferLinkHeader>
      <ReferLinkText>Help share your love of cryptocurrency while being rewarded.</ReferLinkText>
      <ReferShareLink translate="no">
        <RaFCode>app.calebandbrown.com/signup?referrer={data.code}</RaFCode>
        <CopyOnClick text={`app.calebandbrown.com/signup?referrer=${data.code}`}>
          <ReferShareButton onClick={handleAmplitudeTracking}>Copy</ReferShareButton>
        </CopyOnClick>
      </ReferShareLink>
    </ReferLinkWrapper>
  );
};

export default MobileReferral;
